import React from "react";
import { Button as ChakraButton, forwardRef, } from "@chakra-ui/react";
export const Button = forwardRef((props, ref) => {
    return React.createElement(ChakraButton, Object.assign({}, props, { ref: ref }));
});
